import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle'

export function getTableColumns() {
  return [
    {
      type: 'selection',
      width: 60,
      align: 'center',
      fixed: 'left'
    },
    {
      title: '材料商品ID',
      key: 'materialId',
      minWidth: 190,
      fixed: 'left'
    },
    {
      title: '材料商品名称',
      slot: 'offerName',
      minWidth: tableColumnsWidth.type6,
      fixed: 'left'
    },
    {
      title: '材料费显示价格（元）',
      slot: 'materialDisplayPrice',
      width: 150,
      align: 'center'
    },
    {
      title: '价格（元）',
      slot: 'offerPrice',
      width: 120,
      align: 'center'
    },
    {
      title: '学期',
      key: 'yearTermName',
      width: tableColumnsWidth.type4
    },
    {
      title: '学校',
      slot: 'schoolName',
      minWidth: tableColumnsWidth.type6
    },
    {
      title: '提供方',
      slot: 'orgName',
      minWidth: tableColumnsWidth.type6
    },
    {
      title: '是否可见',
      slot: 'isVisible',
      width: 130,
      align: 'center'
    },
    {
      title: '关联课程商品',
      slot: 'classroomName',
      minWidth: tableColumnsWidth.type6
    },
    {
      title: '购买人数',
      key: 'purchaseNum',
      width: 100,
      align: 'center'
    },
    {
      title: '分账规则',
      slot: 'itemName',
      minWidth: tableColumnsWidth.type6
    },
    {
      title: '关联商品的上架状态',
      slot: 'classroomState',
      width: 120,
      align: 'center'
    },
    {
      title: '创建时间',
      key: 'createTime',
      width: 180
    },
    slot('操作', 'action', 70, {
      fixed: 'right'
    })
  ]
}
